import Header from "./sub-components/Header";
import '../../../src/styles/referal.css'
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Link } from 'react-router-dom';
import {getDocs,query,where, collection, getDoc,doc} from 'firebase/firestore'
import {db} from './firebase/firebase';
import {useState,useEffect} from 'react';
import { de_encrypt } from "../../encryption";
import BaseNav from "./sub-components/BaseNav";
import {encrypt} from "../../encryption/"
import { CopyToClipboard } from 'react-copy-to-clipboard';
const Referal = () => {
    const user_id=de_encrypt(localStorage.getItem('user-key'));
    const [first_ref,setFirstRef]=useState("unset");
    const [second_ref,setSecondRef]=useState("null");
    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: "#9900EF",
          color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 14
        },
      }));
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));
  
  function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
  }
  const rows = [
    createData('Owoade123', '#2000', 'Level Refferal bonus', '18/12/2021 12:30', '#2000'),
  ];
  const __convert_date=(seconds)=>{
        return new Date(seconds).toDateString()
    }

  const [refs,setRefs] =useState(null);
  const all_refs = []
  useEffect(()=>{
     if(refs==null){
        ( async ()=>{
            const q = query(collection(db, "referrals"), where("referrer", "==", user_id));
                    const querySnapshot = await getDocs(q);
                    querySnapshot.forEach((doc) => {
                        all_refs.push(doc.data())
             });
             setRefs(all_refs.sort((a,b)=>{return b.time - a.time}))
        })()
     }
        console.log(all_refs)
 
    
  },[refs]) 

  useEffect(()=>{
    if(first_ref == "unset"){
      (async ()=>{
        const docRef = doc(db, "user", user_id);
        const docSnap = await getDoc(docRef);
        setFirstRef(docSnap.data().referrer == null ? "null" : docSnap.data().referrer);
        if(first_ref != null){
          const doc2Ref = doc(db, "user", docSnap.data().referrer);
          const doc2Snap = await getDoc(doc2Ref);
          setSecondRef(doc2Snap.data().referrer == null ? "null" : doc2Snap.data().referrer);
        }
      })();
    }
  },[first_ref])
  if( first_ref != "unset" ){
    return ( 
      <div className="dashboard referal-container utility">
      <Header />  
      <BaseNav active={"Referrals"} />
          <div className="container">
              <h2>Your Referal link</h2>
              <div className="referal-box">
              <span>{`https://viralclicks-mine.net/login?ref=${encrypt(user_id)}-${encrypt(first_ref)}-${encrypt(second_ref)}`}</span>
              <CopyToClipboard text={`https://viralclicks-mine.net/login?ref=${encrypt(user_id)}-${encrypt(first_ref)}-${encrypt(second_ref)}`} >
                <button>Copy</button>
              </CopyToClipboard>
               
              </div>
              <h2>Referal Record</h2>
              <div className="referal-logs">
                           { refs &&  <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 700 }} aria-label="customized table">
                      <TableHead>
                      <TableRow>
                          <StyledTableCell>Username</StyledTableCell>
                          <StyledTableCell align="right">Amount</StyledTableCell>
                          <StyledTableCell align="right">Description&nbsp;</StyledTableCell>
                          <StyledTableCell align="right">Date & Time&nbsp;</StyledTableCell>
                          <StyledTableCell align="right">Balance&nbsp;</StyledTableCell>
                      </TableRow>
                      </TableHead>
                      <TableBody>
                      {refs.map(row => (
                          <StyledTableRow key={row.name}>
                          <StyledTableCell component="th" scope="row">
                              {row.referred}
                          </StyledTableCell>
                          <StyledTableCell align="right">{'Paid'}</StyledTableCell>
                          <StyledTableCell align="right">{'Level 1 bonus'}</StyledTableCell>
                          <StyledTableCell align="right">{__convert_date(row.time)}</StyledTableCell>
                          <StyledTableCell align="right">{'paid'}</StyledTableCell>
                          </StyledTableRow>
                      ))}
                      </TableBody>
                  </Table>
                  </TableContainer> }
              </div>
          </div>
            
      </div>
   );
  }else{
    return(
      <span style={{textAlign:"center"}}>Loading</span>
    )
  }
    
}
 
export default Referal;
